module.exports = __webpack_public_path__ + "static/media/individual-icon-selected.07e5c5c9.svg";